<template>
  <div>
    <v-data-table
      v-model="selected"
      :items="data"
      :headers="fiteredTableHeaders"
      :loading="loading || internalLoading > 0"
      :search="search"
      :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'mdi-arrow-collapse-left',
        lastIcon: 'mdi-arrow-collapse-right',
        prevIcon: 'mdi-minus',
        nextIcon: 'mdi-plus'
      }"
      item-key="id"
      show-select
      class="elevation-1 admin-table"
      loading-text="Loading... Please wait"
    >
      <template v-slot:item.actions="{item}">
        <div class="reports-action-launch" @click="launchRowAction">
          <v-icon>mdi-dots-vertical</v-icon>
          <ActionContainer :ref="item.key" :heading="'Action'" class="report-action-options">
            <ActionItem 
              :disabled="!$can('batchAssignDevicesToAssets')"
              label="Assign"
              icon="mdi-link"
              @click.native="showDialogAddCurrent(item, 'assign')"
            />
            <ActionItem
              label="Device Config"
              :disabled="!$can('updateAsset')"
              icon="mdi-settings"
              @click.native="showDialogAddCurrent(item, 'config')"
            />
          </ActionContainer>
        </div>
      </template>

      <template v-slot:item.created_on="{ item }">
        {{ formatDate(item.created_on) }}
      </template>
    </v-data-table>
  </div>
</template>

<script>

import ActionContainer from '@/components/general/ActionContainer.vue';
import ActionItem from '@/components/general/ActionItem.vue';

import moment from "moment";

// import { Logger } from "aws-amplify"
// const logger = new Logger("Unassigned Assets")

export default {
  name: 'UnassignedAssetsTable',
  components: {
    ActionContainer,
    ActionItem
  },
  props: {
    data: {
      type: Array,
      required: true
    },
    search: {
      type: String,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    clearSelection: {
      type: Number,
      required: false,
      default: 0
    }
  },
  data() {
    return {
      headers: [
        {
          text: 'IMEI',
          value: 'imei',
          align: 'left'
        },
        {
          text: 'Serial',
          value: 'serial_number',
          align: 'left'
        },
        {
          text: 'Make',
          value: 'make',
          align: 'left'
        },
        {
          text: 'Model',
          value: 'model',
          align: 'left'
        },
        {
          text: 'Firmware',
          value: 'firmware',
          align: 'left'
        },
        {
          text: 'ICCID',
          value: 'ICCID',
          align: 'left'
        },
        {
          text: 'Created',
          value: 'created_on',
          align: 'left'
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'left'
        }
      ],
      selected: [],
      presence: {},
      internalLoading: 0
    }
  },

  computed: {
    fiteredTableHeaders () {
				return this.headers.filter(i => !this.hideHeader[i.value])
			},
			hideHeader () {
				return {
					status: !this.$can('getVehiclePresence')
				}
			},
  },

  watch: {
    selected(val) {
      this.$emit('selectionUpdatedAssets', val);
    },

    clearSelection() {
      this.selected = []
    }
  },
  mounted () {

  },
  methods: {
    showDialogAddCurrent(item, type) {
      let selectedAmount = this.selected.length;

      if (item) {
        if(!this.selected.includes(item)) {
          this.selected.push(item);
        }
      } else {
        // Clear selection for single select

        if (selectedAmount === 1) {
          this.selected = [];
        }
      }

      if(type == 'edit') {
        this.$emit('toggleEditAsset')
      }

      if(type == 'device_info') {
        this.$emit('toggleDeviceInfo')
      }

      if(type == 'move') {
        this.$emit('toggleMoveAsset')
      }
      if(type == 'unassign') {
        this.$emit('unassignAssetDevice')
      }
      if(type == 'location') {
        this.$emit('showLocation')
      }
      if(type == 'config') {
        this.$emit('showAssetConfig')
      }
      if(type == 'assign') {
        this.$emit('toggleAssetAssignmentComp');
      }
    },
   
    launchRowAction(e) {
      let allOptions = document.querySelectorAll(".report-action-options");

      for (let option of allOptions) {
        option.classList.remove('active-options');
        if (option === e.target.nextSibling) {
          option.classList.toggle('active-options');
        } 
      }
    },

    formatDate(val) {
      if(!val) return ''
      return moment(val).format('DD MMM YYYY HH:mm:ss')
    },


    toggleFormat(item) {
      this.$emit('toggleFormat', item);
    },
    toggleAssignmentComp() {
      this.$emit('toggleAssetAssignmentComp');
    },
    showInfoModal(item) {
      this.$emit('showUnassignedInfoModal', item);
    },
    toggleReboot(item) {
      this.$emit('toggleReboot', item);
    },
    updateOTC(item) {
      this.$emit('updateOTC', item);
    },
    deleteDevice(item) {
      this.$emit('deleteDevice', item, 'unassigned');
    },
    toggleDeviceConfig(item) {
      this.$emit('toggleDeviceConfig', item)
    }
  }
}
</script>

<style lang="scss">

</style>